/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from "react";
import {useStateContext} from "../utils/web3";
import {Alert, Snackbar} from "@mui/material";

enum Actions {
  START = 1,
  APPROVE_OG,
  APPROVE_HELL,
  SEND_TO_PORTAL,
}

class ActionManager {

  public static getNextAction(action: Actions): Actions {
    switch (action) {
      case Actions.START:
        return Actions.APPROVE_OG
      case Actions.APPROVE_OG:
        return Actions.APPROVE_HELL
      case Actions.APPROVE_HELL:
        return Actions.SEND_TO_PORTAL
    }
    return Actions.START;
  }

  public static getText(action: Actions): string {
    switch (action) {
      case Actions.START:
        return "Loading..."
      case Actions.APPROVE_OG:
        return "Approve the OG Duck to send them through the portal"
      case Actions.APPROVE_HELL:
        return "Approve the Hell Ducks to send them through the portal"
      case Actions.SEND_TO_PORTAL:
        return "SEND TO PORTAL"
    }
  }
}

function ButtonSocial(props: any) {
  const { selectedOgduck, selectedHellduck, selectedSecondduck,hellducks,ogDucks,secondDucks,setHellducks,setSecondDucks,setOgDucks,setFilteredHellducks,setFilteredOgDucks,filteredogDucks,filteredhellducks } = props;
  const [equal, setEquals] = useState<any>([]);
  const [sended, setSended] = useState<any>(false);
  const [loading, setLoading] = useState<any>(false);
  const [action, setAction] = useState<Actions>(Actions.START);
  // Snackbar
  const [snackBarMessage, setSnackBarMessage] = useState<any>('');
  const [isSnackBarOpen, setIsSnackBarOpen] = useState<any>(false);
  const [snackBarSeverity, setSnackBarSeverity] = useState<any>('');

  const { sendThroughPortal, setHellApproval, setOgApproval, isHellApproved, isOgApproved } = useStateContext();

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setIsSnackBarOpen(false);
  };


  useEffect(() => {
    if (selectedHellduck && selectedOgduck ) {
      const traits_equals:any[] = []
      selectedHellduck.traits.map((a:any) => {
        selectedOgduck.traits.map((b:any) => 
          {
            if ( a.trait_type === b.trait_type ){
              if (a.value === b.value) {
                traits_equals.push(a.trait_type);
              }
            }
            return true;
          }
        )
        return true;
      }
      )
      setEquals(traits_equals);
    }
  }, [ selectedOgduck, selectedHellduck ]);

  useEffect(() => {

    const stateMachine = async () => {
      if (action === Actions.START) {
        setLoading(true);
        setAction(Actions.APPROVE_OG);
        return;
      }

      if(action === Actions.APPROVE_OG) {
        if(!await isOgApproved()) {
          setLoading(false);
        } else {
          setAction(Actions.APPROVE_HELL);
        }
        return;
      }

      if(action === Actions.APPROVE_HELL) {
        if(!await isHellApproved()) {
          setLoading(false);
          return;
        } else {
          setAction(Actions.SEND_TO_PORTAL);
        }
      }

      if(action === Actions.SEND_TO_PORTAL) {
        setLoading(false);
      }
    }

    stateMachine().then(console.log);
  }, [ action ]);

  const sendAction = async () => {
    if (loading) return;
    setLoading(true);
    let res = undefined;
    let actionMessage = '';
    try{
      if(action === Actions.APPROVE_OG) {
        actionMessage = 'sending approve OG transaction';
        res = await setOgApproval();
        setAction(Actions.APPROVE_HELL);
      }
      if(action === Actions.APPROVE_HELL) {
        actionMessage = 'sending approve Hell transaction';
        res = await setHellApproval();
        setAction(Actions.SEND_TO_PORTAL);
      }
      if(action === Actions.SEND_TO_PORTAL) {
        actionMessage = 'sending ducks through portal';
        res = await sendThroughPortal(
            selectedOgduck.token_id,
            selectedHellduck.token_id,
            selectedSecondduck.token_id
        );
      }

    } catch(e) {
      console.log("error");
      setIsSnackBarOpen(true);
      setSnackBarSeverity('error')
      setSnackBarMessage("Error " + actionMessage)
    }
    setLoading(false);
    console.log(res);
    if(res) {
      setIsSnackBarOpen(true);
      setSnackBarSeverity('success')
      setSnackBarMessage("Success " + actionMessage)

    }
    if(action === Actions.SEND_TO_PORTAL) {
      if (res) {
        setSended(true);
        setOgDucks(
          ogDucks.filter((duck:any) => duck.token_id !== selectedOgduck.token_id)
        )
        setFilteredOgDucks(
          filteredogDucks.filter((duck:any) => duck.token_id !== selectedOgduck.token_id)
        )
        setSecondDucks(
          secondDucks.filter((duck:any) => duck.token_id !== selectedSecondduck.token_id)
        )
        setHellducks(
          hellducks.filter((duck:any) => duck.token_id !== selectedHellduck.token_id)
        )
        setFilteredHellducks(
          filteredhellducks.filter((duck:any) => duck.token_id !== selectedHellduck.token_id)
        )
      }
    }
  }

  return (
    <div className="flex flex-col items-center p-10">
      {
        sended ? 
        <div className="m-auto leading-normal text-center uppercase txt-white text-4xl md:text-2xl mb-2">
          Congratulations! <br>
          </br>Transaction sended 
        </div>
        :
        <>
          <div className="flex flex-row justify-around w-full">
            <div className="flex flex-col items-center justify-center">
              <div className="m-auto leading-normal uppercase txt-white text-4xl md:text-2xl mb-2"> 
                OG duck #{selectedOgduck.token_id}
              </div>
              <img src={selectedOgduck.image_url} alt="" className={`rounded-lg resize w-4/5 md:w-3/5`}/>
            </div>
            <div className="flex flex-col items-center">
              <div className="m-auto leading-normal uppercase txt-white text-4xl md:text-2xl mb-2"> 
                Hell duck #{selectedHellduck.token_id}
              </div>
              <img src={selectedHellduck.image_url} alt="" className={`rounded-lg resize w-4/5 md:w-3/5`}/>
            </div>
          </div>
          <div className="m-auto leading-normal uppercase txt-white text-4xl md:text-3xl my-2"> 
              {equal.length} MATCHES
          </div>
          <div className="flex flex-row justify-around w-full">
            <div className="flex flex-col items-start">
              {
                selectedOgduck.traits.sort((a:any, b:any) => a.trait_type.localeCompare(b.trait_type)).map((i:any, index:any) => (
                  <div key={index} className={`leading-normal uppercase ${equal.includes(i.trait_type)?'text-yellow':'txt-white'} text-4xl md:text-lg`}> 
                      {i.trait_type}: {i.value}
                  </div>
              ))}
            </div>
            <div className="flex flex-col items-end">
              {
                selectedHellduck.traits.sort((a:any, b:any) => a.trait_type.localeCompare(b.trait_type)).map((i:any, index:any) => (
                  <div key={index} className={`leading-normal uppercase ${equal.includes(i.trait_type)?'text-yellow':'txt-white'} text-4xl md:text-lg`}> 
                      {i.trait_type}: {i.value}
                  </div>
              ))}
            </div>
          </div>
          <div className="flex flex-row justify-around w-full mt-10 items-center">
            <div className="flex flex-col items-center ">
              <div className="m-auto leading-normal uppercase txt-white text-4xl md:text-2xl mb-2"> 
                2ND GEN DUCK #{selectedSecondduck.token_id}
              </div>
              <img src={selectedSecondduck.image_original_url} alt="" className={`rounded-lg resize w-3/5 md:w-2/5`}/>
            </div>
            <button onClick={sendAction} className="flex blue-button-bg rounded-lg h-2/4 px-6 md:px-16 py-5">
            {
              loading ? 
              <div className="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
              :
              <div className="m-auto leading-normal uppercase txt-black text-4xl md:text-4xl">
                {ActionManager.getText(action)}
              </div>
            }
            </button>
          </div>
          <Snackbar
              open={isSnackBarOpen}
              autoHideDuration={6000}
              onClose={handleClose}
          >
            <Alert severity={snackBarSeverity} sx={{ width: '100%' }}>
              {snackBarMessage}
            </Alert>
          </Snackbar>
        </>

      }
    </div>
  );
}

export default ButtonSocial;